module.exports = __webpack_public_path__ + "img/fecha.5cb5630c.svg";